import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { firebaseAuth } from "./config/firebase";


import Login from "./pages/Login/Login";
import Articles from "./pages/Articles/Articles";
import Polls from "./pages/Polls/Polls";
import Comments from "./pages/Comments/Comments";
import AddArticle from "./pages/AddArticle/AddArticle";
import EditArticle from "./pages/EditArticle/EditArticle";
import MyProfile from "./pages/MyProfile/MyProfile";

import { Provider, useSelector, useDispatch } from "react-redux";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from '@material-ui/core/styles';
import d24hTheme from "./themes/diario-admin";

import initialStore from "./store/store";
import api from "./services/api";

import "./core.scss";
import { LinearProgress } from "@material-ui/core";

const { store, persistor } = initialStore();

const PrivateRoute = ({ component: Component, ...rest }) => {

  const { user } = useSelector((store) => store);
  
  return (
    <Route
      {...rest}
      render={(props) =>
        user?.isLogged ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const App = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    firebaseAuth.onAuthStateChanged((user) => {
      if (user) {
        api.get(`/users/getAdminByUid/${user.uid}`).then((response) => {
          dispatch({
            type: "@auth/LOGGED_USER",
            payload: {
              user: response.data,
            },
          });
        })
      .catch((_) => {})
      }
      setLoading(false)
    });
  }, [dispatch]);

  if (loading) return <LinearProgress />;

  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute path="/editar-artigo/:id" component={EditArticle} />
        <PrivateRoute path="/adicionar-artigo" component={AddArticle} />
        <PrivateRoute path="/artigos" component={Articles} />
        <PrivateRoute path="/enquetes" component={Polls} />
        <PrivateRoute path="/comentarios" component={Comments} />
        <PrivateRoute path="/meu-perfil" component={MyProfile} />
        <Route path="*" component={Login} />
      </Switch>
    </BrowserRouter>
  );
};

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
    <ThemeProvider theme={ d24hTheme }>
      <CssBaseline />
      <App />
    </ThemeProvider>
      
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
